export default __webpack_public_path__ + "static/5-3c08b571afe01c5981332510babe6953.jpg";